import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createBatch } from "../../actions/batchActions";
import { getInstitutions } from "../../actions/institutionActions";
import Select from 'react-select';

import classnames from "classnames";

class NewBatch extends Component {
  constructor() {
    super();
    this.state = {
      cycleDate: "",
      totalAmount: "",
      receiptNumber: "",
      description: "",
      institution: "",
      male: "",
      female: "",
      errors: {}
    };
    this.saveBatch = this.saveBatch.bind(this);
    this.cancel = this.cancel.bind(this);
    this.handleInstitutionChange = this.handleInstitutionChange.bind(this);
    this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
  }

  componentDidMount() {
    this.props.getInstitutions();
  }
  //life cycle hooks
  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  onChange = e => this.setState({ [e.target.name]: e.target.value });

  handleInstitutionChange(val) {
    this.setState({ institution: val });
  }

  handleCurrencyChange(val) {
    this.setState({ currency: val.value });
  }

  saveBatch = e => {
    e.preventDefault();
    let batch = {
      cycleDate: this.state.cycleDate,
      totalAmount: this.state.totalAmount,
      receiptNumber: this.state.receiptNumber,
      description: this.state.description,
      institution: this.state.institution,
      currency:this.state.currency,
      male: this.state.male,
      female: this.state.female
    };

    this.props.createBatch(batch, this.props.history);

  };

  cancel() {
    this.props.history.push("/batch-list");
  }

  render() {
    const { errors } = this.state;
    const { institutions } = this.props.institution
    const currencies=[{value:"ZWL",label:"ZWL"},{value:"USD",label:"USD"},{value:"ZWG",label:"ZWG"}]
    
    return (
      <div className="container">

        <div className="card m-auto  border-primary shadow-lg rounded p-3">
          <h5 className="display-4 text-center">New Accounts Batch</h5>
          <p className="lead text-center">Enter details for new Batch</p>
          <hr />
          {errors.message && <div className="alert alert-danger text-center" role="alert">
            {errors.message}
          </div>}
          <form onSubmit={this.saveBatch}>
            <div className="row">
              <div className="form-group col-sm-6">
                <label>Institution</label>
                <Select
                  className="react-selectcomponent"
                  classNamePrefix="name-select"
                  onChange={this.handleInstitutionChange}
                  getOptionLabel={institution => `${institution.institutionName}`}
                  isOptionSelected={true}
                  getOptionValue={institution => `${institution}`}
                  options={institutions}
                  required
                />
              </div>
              <div className="form-group col-sm-6">
                <label>Date Of Cycle</label>
                <input
                  className={classnames("form-control",
                    { "is_invalid": errors.cycleDate })}
                  type="date"
                  name="cycleDate"
                  onChange={this.onChange}
                  value={this.state.cycleDate || ""}
                  required
                />
                {errors.cycleDate && (
                  <div className="invalid-feedback">
                    {errors.cycleDate}
                  </div>
                )}
              </div>

              <div className="form-group col-sm-6">
                <label >Amount</label>
                <input
                  className={classnames("form-control",
                    { "is-invalid": errors.totalAmount })}
                  type="number"
                  required
                  name="totalAmount"
                  id="totalAmount"
                  value={this.state.totalAmount}
                  onChange={this.onChange}
                  placeholder="Amount"

                />
                {errors.totalAmount && (
                  <div className="invalid-feedback">
                    {errors.totalAmount}
                  </div>
                )}
              </div>
              <div className="form-group col-sm-6">
                <label>Currency</label>
                <Select
                  className="react-selectcomponent"
                  classNamePrefix="name-select"
                  onChange={this.handleCurrencyChange}
                  options={currencies}
                  required
                />
              </div>

              <div className="form-group col-sm-6">
                <label >Male</label>
                <input
                  className={classnames("form-control",
                    { "is-invalid": errors.male })}
                  type="number"
                  min="0"
                  name="male"
                  id="male"
                  required
                  value={this.state.male}
                  onChange={this.onChange}
                  placeholder="Male"

                />
                {errors.male && (
                  <div className="invalid-feedback">
                    {errors.male}
                  </div>
                )}
              </div>

              <div className="form-group col-sm-6">
                <label >Female</label>
                <input
                  className={classnames("form-control",
                    { "is-invalid": errors.female })}
                  type="number"
                  min="0"
                  name="female"
                  id="female"
                  required
                  value={this.state.female}
                  onChange={this.onChange}
                  placeholder="Female"

                />
                {errors.female && (
                  <div className="invalid-feedback">
                    {errors.female}
                  </div>
                )}
              </div>


              <div className="form-group col-sm-6">
                <label >Reference Number</label>
                <input
                  className={classnames("form-control",
                    { "is-invalid": errors.receiptNumber })}
                  type="text"
                  name="receiptNumber"
                  id="receiptNumber"
                  value={this.state.receiptNumber}
                  onChange={this.onChange}
                  placeholder="Receipt Number"
                  required

                />
                {errors.receiptNumber && (
                  <div className="invalid-feedback">
                    {errors.receiptNumber}
                  </div>
                )}
              </div>

              <div className="form-group col-sm-6">
                <label >Description</label>
                <input
                  className={classnames("form-control",
                    { "is-invalid": errors.description })}
                  type="text"
                  name="description"
                  id="description"
                  value={this.state.description}
                  onChange={this.onChange}
                  placeholder="Description"
                  required

                />
                {errors.description && (
                  <div className="invalid-feedback">
                    {errors.description}
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="form-group col-sm-6">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mt-4"

                >Save</button>
              </div>
              <div className="form-group col-sm-6">
                <button
                  type="button"
                  className="btn btn-secondary btn-block mt-4"
                  onClick={this.cancel}
                >Cancel</button>
              </div>
            </div>
          </form>
        </div>
      </div>

    );
  }
}

NewBatch.propTypes = {
  createBatch: PropTypes.func.isRequired,
  getInstitutions: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  institution: state.institution,
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { createBatch, getInstitutions }
)(NewBatch);
